import styled from 'styled-components';
import type { FunctionComponent } from 'react';
import { paletteHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import { DialogModal } from '../../app-kit/components/DialogModal/DialogModal';

interface NearbyChildcareDisclaimerProps {
  opened: boolean;
  onClose: () => void;
}

const BodyText = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
`;

export const NearbyChildcareDisclaimer: FunctionComponent<NearbyChildcareDisclaimerProps> = ({
  opened,
  onClose,
}) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="Childcare data"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
      gap="0"
    >
      <BodyText>
        Childcare information is provided by Care For Kids Group Pty Ltd. Realestate.com.au Pty Ltd
        makes no representations about its accuracy. Always contact the service provider and make
        your own enquiries before making any decisions relating to a service provider.
      </BodyText>
    </DialogModal>
  );
};
